const getTelNumber = state => state.tel_number
const getCode = state => state.code
const getIsAuthenticated = state => state.isAuthenticated

export default {
    getTelNumber,
    getCode,
    getIsAuthenticated
}